import React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import Typography from "../Typography";
import Button from "../Button";
import Modal from "../Notification/ModalNotification";


const styles = theme => ({
  banner: {
    background: "#E75F75",
    height: 32,
    width: "100%",
    padding: "4px 16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  },
  bannerText: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  },
  bannerAction: {
    display: "flex",
    alignItems: "center",
    position: "relative",
    zIndex: 1000
  },
  buttonMargin: {
    margin: "0px 12px",
    fontSize: 12,
    fontWeight: 500,
    lineHeight: 1.3
  },
  customButton: {
    borderRadius: "0px"
  },
  feedBox: {
    position: "absolute",
    right: 124,
    top: 40,
    width: 500,
    height: 270,
    [theme.breakpoints.down("sm")]: {
      width: 375,
      right: 0
    },
    border: "1px solid #EEE",
    background: "#FFF",
    zIndex: 2000,
    padding: 24,
    boxSizing: "border-box",
    boxShadow: "0px 4px 4px rgba(88, 88, 88, 0.25)",
    overflow: "hidden"
  },
  feedContainer: {
    margin: "16px 0px 16px 0px"
  },
  textArea: {
    width: "100%",
    height: "136px !important",
    overflowY: "scroll",
    margin: 0,
    fontSize: 16,
    fontFamily: "Open Sans, sans-serif",
    color: "#000",
    padding: 12,
    "&:focus": {
      outline: "1px solid #DDD"
    },
    "&:active": {
      outline: "1px solid #DDD"
    },
    border: "1px solid #DDD",
    boxSizing: "border-box"
  },
  upArrow: {
    borderColor: "#EEE transparent",
    borderStyle: "solid",
    height: 0,
    width: 0,
    borderWidth: "0px 16px 16px 16px",
    position: "absolute",
    top: "25px",
    right: "150px",
    zIndex: 2001,
    [theme.breakpoints.down("sm")]: {
      right: "52px"
    }
  },
  upArrow2: {
    borderColor: "#FFF transparent",
    borderStyle: "solid",
    height: 0,
    width: 0,
    borderWidth: "0px 14px 14px 14px",
    position: "absolute",
    top: "27px",
    right: "152px",
    zIndex: 2001,
    [theme.breakpoints.down("sm")]: {
      right: "54px"
    }
  }
});

class Banner extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      confirm: false,
      feedBack: props.type === "approval" && props.openFeedback ? true : false,
      approvalFeedback: ""
    };
  }

  handleLater = () => {
    this.setState({
      feedBack: true
    });
  };

  handleAction = () => {
    this.setState({
      confirm: true,
      feedBack: false,
      approvalFeedback: ""
    });
  };

  handleChange = e => {
    this.setState({
      approvalFeedback: e.target.value
    });
  };

  handleCancel = () => {
    this.setState({
      feedBack: false,
      confirm: false,
      approvalFeedback: ""
    });
  };

  handleSend = () => {
    this.setState(
      {
        feedBack: false
      },
      () => {
        this.props.handleLater(this.state.approvalFeedback);
      }
    );
  };

  confirmAction = () => {
    this.setState(
      {
        confirm: false,
        feedBack: false
      },
      () => {
        this.props.handleAction();
      }
    );
  };

  render() {
    const {
      classes,
      type,
      color,
      banner,
      laterButton,
      actionButton,
      handleLater,
      handleAction,
      header,
      body,
      primary_cta_text,
      secondary_cta_text
    } = this.props;
    const { confirm, feedBack, approvalFeedback } = this.state;

    return (
      <>
        <Modal
          open={confirm}
          header={header}
          body={body}
          primary_cta_text={primary_cta_text}
          primary_cta_action={this.confirmAction}
          secondary_cta_text={secondary_cta_text}
          secondary_cta_action={this.handleCancel}
        />

        <div className={classes.banner} style={{ background: color }}>
          <Typography
            type="body2"
            color="white"
            font_weight="500"
            className={classes.bannerText}
          >
            {banner}
          </Typography>
          <div className={classes.bannerAction}>
            {laterButton && (
              <Button
                variant="tertiary"
                size="sm"
                state="active"
                color="white"
                onClick={type === "approval" ? this.handleLater : handleLater}
                className={classes.buttonMargin}
              >
                {laterButton}
              </Button>
            )}
            {actionButton && (
              <Button
                variant="secondary"
                size="sm"
                state="active"
                color="white"
                onClick={type === "approval" ? this.handleAction : handleAction}
                className={`${classes.buttonMargin} ${classes.customButton}`}
              >
                {actionButton}
              </Button>
            )}
          </div>
        </div>
        {feedBack && (
          <>
            <div className={classes.upArrow}></div>
            <div className={classes.upArrow2}></div>
            <div className={classes.feedBox}>
              <Typography type="body1" color="black">
                Give Feedback
              </Typography>
              <div className={classes.feedContainer}>
                <TextareaAutosize
                  placeholder="Please provide feedback here..."
                  className={classes.textArea}
                  rowsMin={6}
                  value={approvalFeedback}
                  onChange={this.handleChange}
                />
              </div>
              <Button
                onClick={this.handleSend}
                variant="primary"
                size="sm"
                state={approvalFeedback ? "active" : "inactive"}
                color="hylyBlue"
              >
                Send
              </Button>
              <Button
                onClick={this.handleCancel}
                variant="tertiary"
                size="sm"
                state="active"
                color="hylyBlue"
              >
                Cancel
              </Button>
            </div>
          </>
        )}
      </>
    );
  }
}

Banner.propTypes = {
  color: PropTypes.string,
  banner: PropTypes.string,
  laterButton: PropTypes.string,
  actionButton: PropTypes.string,
  header: PropTypes.string,
  body: PropTypes.string,
  primary_cta_text: PropTypes.string,
  secondary_cta_text: PropTypes.string
};

Banner.defaultProps = {
  color: "#E75F75",
  banner: "Banner Text...",
  header: "Confirm Approve",
  body: "Are you sure you want to approve this eBlast?",
  primary_cta_text: "Approve",
  secondary_cta_text: "Cancel"
};

export default withStyles(styles)(Banner);
